module.exports = __webpack_public_path__ + "img/220.52a78852.jpg";